import { useAtom } from "jotai";
import { useCallback } from "react";
import { ChatMessageWindowStore } from "../stores/ChatMessageWindowStore";

export function useChatMessageWindowStore() {
  const [chatMessageWindowStore, setChatMessageWindowStore] = useAtom(ChatMessageWindowStore);

  const openChat = useCallback(
    function openChat() {
      setChatMessageWindowStore((oldWindowStore) => ({ ...oldWindowStore, open: true }));
    },
    [setChatMessageWindowStore]
  );

  const closeChat = useCallback(
    function closeChat() {
      setChatMessageWindowStore((oldWindowStore) => ({ ...oldWindowStore, open: false }));
    },
    [setChatMessageWindowStore]
  );

  const toggleChat = useCallback(
    function toggleChat() {
      setChatMessageWindowStore((oldWindowStore) => {
        return { ...oldWindowStore, open: !oldWindowStore.open };
      });
    },
    [setChatMessageWindowStore]
  );

  const enableChat = useCallback(
    function enableChat() {
      setChatMessageWindowStore((oldWindowStore) => ({ ...oldWindowStore, disabled: false }));
    },
    [setChatMessageWindowStore]
  );

  const disableChat = useCallback(
    function disableChat() {
      setChatMessageWindowStore((oldWindowStore) => ({ ...oldWindowStore, disabled: true }));
    },
    [setChatMessageWindowStore]
  );

  return {
    chatState: chatMessageWindowStore.open,
    disabled: chatMessageWindowStore.disabled,
    openChat,
    closeChat,
    toggleChat,
    enableChat,
    disableChat,
  };
}
